"use client";

import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import {
  resolveTenantRouteContext,
} from "@/shared/lib/branch/branch-admin-routing";
import { isAuthAppRoute, normalizeTenantPathname } from "@/shared/lib/routing/app-route-scope";

/**
 * Workspace + branch segment for scoped admin URLs. `useParams()` should now be present under
 * React Router route matching, while pathname parsing remains as a safe fallback.
 * Auth routes like `/login/factor-one` also match `/:seg/:seg` — never treat those as workspace/branch.
 */
export function useAdminRouteSlugs() {
  const location = useLocation();
  return useMemo(() => {
    const normalized = normalizeTenantPathname(location.pathname);
    if (isAuthAppRoute(normalized)) {
      return {
        workspaceSlug: undefined,
        branchSlug: undefined,
      };
    }
    const context = resolveTenantRouteContext(location.pathname);
    return {
      workspaceSlug: context.workspaceSlug ?? undefined,
      branchSlug: context.branchSlug ?? undefined,
    };
  }, [location.pathname]);
}
